import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

// import components
import CompareTrayProducts from '@/kenwood/components/molecules/CompareTrayProducts';
import CompareTrayCtas from '@/kenwood/components/molecules/CompareTrayCtas';

const CompareTray = ({
  products,
  productsCount,
  compareDataReady,
  titleLabel,
  ctasLabel,
  compareCtaLabel,
  clearCtaLabel,
  onPopProduct,
  onOpenCompare,
  onClearCompare,
}) => {
  const [isOpen, toggleIsOpen] = useState(false);
  const trayRef = useRef();
  const bottomRef = useRef();
  useEffect(() => {
    if (compareDataReady) {
      trayRef.current.style.transform = `translateY(${bottomRef.current.offsetHeight}px)`;
    }
  }, [compareDataReady]);
  useEffect(() => {
    trayRef.current.style.transform = `translateY(${bottomRef.current.offsetHeight}px)`;
  }, [isOpen]);
  return (
    <section
      ref={trayRef}
      className={`ken-compare__tray ken-wrapper--full-grid ${
        compareDataReady ? ' --visible' : ''
      } ${isOpen ? ' --open' : ''}`}
    >
      <button
        type='button'
        className='ken-compare__tray__title ken-wrapper--big-grid'
        onClick={() => toggleIsOpen(!isOpen)}
      >
        {titleLabel} <i className='ken-icon ken-icon--down-black' />
      </button>
      <section
        ref={bottomRef}
        className='ken-compare__tray__bottom ken-wrapper--big-grid'
      >
        <CompareTrayProducts products={products} onPopProduct={onPopProduct} />
        <CompareTrayCtas
          productsCount={productsCount}
          ctasLabel={ctasLabel}
          compareCtaLabel={compareCtaLabel}
          clearCtaLabel={clearCtaLabel}
          onOpenCompare={onOpenCompare}
          onClearCompare={onClearCompare}
        />
      </section>
    </section>
  );
};

CompareTray.propTypes = {
  products: PropTypes.arrayOf(PropTypes.shape()),
  productsCount: PropTypes.number,
  compareDataReady: PropTypes.bool,
  titleLabel: PropTypes.string,
  ctasLabel: PropTypes.string,
  compareCtaLabel: PropTypes.string,
  clearCtaLabel: PropTypes.string,
  onPopProduct: PropTypes.func,
  onOpenCompare: PropTypes.func,
  onClearCompare: PropTypes.func,
};

CompareTray.defaultProps = {
  products: [],
  productsCount: 0,
  compareDataReady: false,
  titleLabel: 'COMPARE PRODUCTS',
  ctasLabel: 'Select up to 3 products to compare',
  compareCtaLabel: 'COMPARE',
  clearCtaLabel: 'CLEAR ALL',
  onPopProduct: null,
  onOpenCompare: null,
  onClearCompare: null,
};

export default CompareTray;
